(function() {
    'use strict';

    angular.module('allegro')
        .controller('AllegroConfigurationListController', AllegroConfigurationListController);

    AllegroConfigurationListController.$inject = [
        '$state',
        'lodashService',
        'notificationSrvc',
        'filterQuerySrvc',
        'datatableDefaultPageSizeValueConst',
        'checkSearchSrvc',
        'allegroConfigDataSrvc',
        'allegroConfigMessagesConst',
        'allegroSrvc',
        'allegroConfigPermissionsConst'
    ];

    function AllegroConfigurationListController(
        $state, lodashService, notificationSrvc, filterQuerySrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc,
        allegroConfigDataSrvc, allegroConfigMessagesConst, allegroSrvc, allegroConfigPermissionsConst
    ) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.modelRows = [];
        self.modelCols = [
            {
                title: 'Client ID',
                value: 'client_id',
                type: 'text',
                searchable: false,
                orderable: false
            },
            {
                title: 'Adres uwierzytelniający',
                value: 'base_url',
                type: 'text',
                searchable: false,
                orderable: false
            },
            {
                title: 'Adres API',
                value: 'base_api_url',
                type: 'text',
                searchable: false,
                orderable: false
            },
            {
                title: 'Data dodania',
                value: 'date_added',
                searchable: true,
                orderable: true,
            },
            {
                title: 'Data modyfikacji',
                value: 'date_modified',
                searchable: true,
                orderable: true,
            },
            {
                title: 'Edytowano przez',
                value: 'last_modified_by',
                searchable: true,
                orderable: true,
            }
        ];

        self.modelPermissions = allegroConfigPermissionsConst;
        self.searchQuery = {};

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getConfigurations();
        }

        function getConfigurations(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                };
            }
            return allegroConfigDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.modelRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getConfigurations);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.allegro-configurations.create');
        }

        function onEdit(row) {
            $state.go('layout.allegro-configurations.update', { pk: row.pk });
        }

        function onDelete(row) {
            return allegroSrvc.remove(row.client_id, row.pk, function(response) {
                notificationSrvc.notification("success", allegroConfigMessagesConst.delete);
                lodashService.remove(self.modelRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getConfigurations();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getConfigurations();
        }
    }
})();
